import type { FC } from 'react';

export const GlobeIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 8H14M2 8C2 11.3137 4.68629 14 8 14M2 8C2 4.68629 4.68629 2 8 2M14 8C14 11.3137 11.3137 14 8 14M14 8C14 4.68629 11.3137 2 8 2M8 14C3.17041 8.72 5.98767 3.8 8 2M8 14C12.8296 8.72 10.0123 3.8 8 2"
      stroke={props.color || '#E6E6E9'}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
